"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableCell = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var currency_1 = require("../../../../../formatters/currency");
var input_1 = (0, tslib_1.__importDefault)(require("../../shared/input"));
var table_1 = require("../../shared/table");
function EditableCell(props) {
    var testId = props.testId, onChange = props.onChange, value = props.value, isEditable = props.isEditable, width = props.width;
    var _a = (0, react_1.useState)(false), isEditing = _a[0], setEditing = _a[1];
    var isString = typeof value === 'string';
    return (react_1.default.createElement(table_1.StyledCell, { textAlign: isString ? 'left' : null }, isEditing ? (react_1.default.createElement(input_1.default, { isEditable: isEditable, testId: "".concat(testId, "-editable"), onChange: function (val) { return onChange(val); }, onBlur: function () { return setEditing(false); }, value: isString ? value : "".concat(isEditable ? '' : '$').concat((0, currency_1.currencyFormat)(value)), placeholder: isString ? '' : null, textAlign: isString ? 'left' : 'right', width: width, isString: isString })) : (react_1.default.createElement(input_1.default, { isEditable: isEditable, testId: testId, onClick: function () {
            if (isEditable) {
                setEditing(true);
            }
        }, value: isString ? value : "".concat(isEditable ? '' : '$').concat((0, currency_1.currencyFormat)(value)), onFocus: function () {
            if (isEditable) {
                setEditing(true);
            }
        }, readOnly: true, placeholder: isString ? '' : null, textAlign: isString ? 'left' : 'right', width: width, isString: isString }))));
}
exports.EditableCell = EditableCell;
//# sourceMappingURL=editable-cell.js.map